import React from 'react';

import cn from 'classnames';

import { useTheme } from 'hooks';
import Box from 'UIKit/Box';

import classes from './TagBox.module.scss';

const TagBox = (props: React.ComponentProps<typeof Box>) => {
  const { activeTheme } = useTheme();
  const { className, ...restProps } = props;

  return (
    <Box
      className={cn(classes.wrapper, classes[activeTheme], className)}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...restProps}
    />
  );
};

export { TagBox };
